import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import CreateContextProvider from './store/Context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <CreateContextProvider>
    <App />
  </CreateContextProvider>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

